<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2 mt-3" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> Volver
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            <div class="divisor">
              Crear nueva unidad de medida
            </div>
          </b-col>
        </b-row>

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="codigo">
                <template v-slot:label>
                  Código <span class="text-danger">*</span>
                </template>
                <b-form-input id="codigo" v-model="form.codigo" required
                  placeholder="Código"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Código (EN)" label-for="codigoEn">
                <b-form-input id="codigoEn" v-model="form['codigoEn']"
                  placeholder="Código (EN)"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombre">
                <template v-slot:label>
                  Nombre <span class="text-danger">*</span>
                </template>
                <b-form-input id="nombre" v-model="form.nombre" required
                  placeholder="Nombre"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Nombre (EN)" label-for="nombreEn">
                <b-form-input id="nombreEn" v-model="form['nombreEn']"
                  placeholder="Nombre (EN)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="simbolo">
                <template v-slot:label>
                  Símbolo <span class="text-danger">*</span>
                </template>
                <b-form-input id="simbolo" v-model="form.simbolo" required
                  placeholder="Símbolo"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label-for="tipo">
                <template v-slot:label>
                  Tipo <span class="text-danger">*</span>
                </template>
                <b-form-input id="tipo" v-model="form.tipo" required
                  placeholder="Tipo"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Tipo (EN)" label-for="tipoEn">
                <b-form-input id="tipoEn" v-model="form['tipoEn']"
                  placeholder="Tipo (EN)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Orden" label-for="orden">
                <b-form-input id="orden" type="number" v-model.number="form.orden"
                  placeholder="Orden"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label="Factor de conversión base" label-for="factorConversionBase">
                <b-form-input id="factorConversionBase" type="number" step="any" v-model.number="form.factorConversionBase"
                  placeholder="Factor de conversión base"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="ID unidad base" label-for="idUnidadBase">
                <b-form-input id="idUnidadBase" type="number" v-model.number="form.idUnidadBase"
                  placeholder="ID unidad base"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4" class="mb-3">
              <b-form-checkbox v-model="form.esBase" switch>
                Es unidad base
              </b-form-checkbox>
            </b-col>
            <b-col md="4" class="mb-3">
              <b-form-checkbox v-model="form.permiteDecimales" switch>
                Permite decimales
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group label="Descripción" label-for="descripcion">
                <b-form-textarea id="descripcion" v-model="form.descripcion" rows="3"
                  placeholder="Descripción"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Descripción (EN)" label-for="descripcionEn">
                <b-form-textarea id="descripcionEn" v-model="form['descripcionEn']" rows="3"
                  placeholder="Descripción (EN)"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">
            Guardar
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import unidadMedidaService from '@/api/unidadMedidaService';
import Swal from 'sweetalert2';

export default {
  name: 'UnidadMedidaCrear',
  data() {
    return {
      form: {
        codigo: '',
        codigoEn: '',
        nombre: '',
        nombreEn: '',
        simbolo: '',
        tipo: '',
        tipoEn: '',
        orden: null,
        factorConversionBase: 1,
        idUnidadBase: null,
        esBase: false,
        permiteDecimales: false,
        descripcion: '',
        descripcionEn: '',
      },
    };
  },
  methods: {
    submitForm() {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Revisa los datos antes de continuar.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Crear unidad de medida',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.close();
          return;
        }

        try {
          Swal.fire({
            html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                  '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                  '<div><h3 style="color:#006393;">Creando...</h3></div>' +
                  '</div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          const response = await unidadMedidaService.create(this.form);

          if (!response || !response.data) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
            return;
          }

          Swal.fire({
            title: 'Creado correctamente',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          const data = response.data;
          const newId = (data && data.id) ? data.id : null;

          if (newId) {
            this.$router.push({ name: 'unidad-medida-detalle', params: { id: newId } });
          } else {
            this.$router.push({ name: 'unidades-medida' });
          }
        } catch (error) {
          const raw = (error && error.response) ? error.response.data : error;
          try { console.error('Create unidad medida error payload:', raw); } catch (e) { /* noop */ }

          let status = 0;
          if (error && error.response && typeof error.response.status !== 'undefined') {
            status = error.response.status;
          }

          let msg = 'Error';
          if (typeof raw === 'string') {
            msg = raw;
          } else if (raw && (raw.message || raw.Message || raw.error || raw.title || raw.detail)) {
            msg = String(raw.message || raw.Message || raw.error || raw.title || raw.detail);
          } else if (error && error.message) {
            msg = error.message;
          } else {
            try { msg = JSON.stringify(raw, null, 2); } catch (e) { msg = 'Error'; }
          }

          const title = (status === 409) ? 'La unidad de medida ya existe' :
                        (status === 400) ? 'Datos inválidos' : 'Oops...';
          const icon  = (status === 409 || status === 400) ? 'warning' : 'error';

          Swal.fire({
            icon: icon,
            title: title,
            html: '<pre style="font-family: inherit;text-align:center;white-space:pre-wrap;margin:0">' + msg + '</pre>',
          });
        }
      });
    },
  },
};
</script>
